import { isLightChatLayoutState } from 'hooks/useChatLayoutType';
import { atom, useAtomValue, useSetAtom } from 'jotai';

const sideModeCacheKey = '@fett/phraseSideModeState';

const sideModeAtom = atom(Boolean(localStorage.getItem(sideModeCacheKey)));

const sideModeState = atom(
  (get) => {
    const sideMode = get(sideModeAtom);
    const isLightChatLayout = get(isLightChatLayoutState);
    if (isLightChatLayout) {
      return false;
    }
    return sideMode;
  },
  (_, set, next: boolean) => {
    set(sideModeAtom, next);
    if (next) {
      localStorage.setItem(sideModeCacheKey, 'true');
    } else {
      localStorage.removeItem(sideModeCacheKey);
    }
  },
);

export const usePhraseSideModeValue = () => useAtomValue(sideModeState);
export const useSetPhraseSideMode = () => useSetAtom(sideModeState);
